// extracted by mini-css-extract-plugin
export default {"root":"onboardingModal_root__YUdd0","form":"onboardingModal_form__HY+tO"};